import { render, staticRenderFns } from "./BankJournalTenantTab.vue?vue&type=template&id=72741a35&scoped=true"
import script from "./BankJournalTenantTab.vue?vue&type=script&lang=js"
export * from "./BankJournalTenantTab.vue?vue&type=script&lang=js"
import style0 from "./BankJournalTenantTab.vue?vue&type=style&index=0&id=72741a35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72741a35",
  null
  
)

export default component.exports